import React from 'react';
import PropTypes from 'prop-types';
import AppContentComponent from '../../components/AppContent';
import RegisterForm from '../../forms/RegisterForm'
import PublicAuthHeader from '../../components/PublicAuthHeader';

const RegisterPage = ({
  onBack,
  header,
  registrationInfo,
  lookupLoading,
  lookupError,
  onRetryLookup,
  brandName,
  onGoToForgotPassword,
}, context) => (
  <AppContentComponent hideLayoutElements hideAssistance>
    <PublicAuthHeader
      onBack={onBack}
      title={header}
      subtitle={context.t('Join our loyalty program in just a few clicks. Complete the registration form and unlock exclusive benefits designed just for you.')}
    />
    <div className="w-full" id="register-form">
      <RegisterForm
        registrationInfo={registrationInfo}
        lookupLoading={lookupLoading}
        lookupError={lookupError}
        onRetryLookup={onRetryLookup}
        onBack={onBack}
        brandName={brandName}
        onGoToForgotPassword={onGoToForgotPassword}
      />
    </div>
  </AppContentComponent>
);

RegisterPage.propTypes = {
  header: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  brandName: PropTypes.string,
  onGoToForgotPassword: PropTypes.func.isRequired,
  lookupLoading: PropTypes.bool,
  lookupError: PropTypes.bool,
  onRetryLookup: PropTypes.func,
}

RegisterPage.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default RegisterPage;
